import { ModelsUseCase } from '../../../data/usecases'
import { makeAxiosHttpClient } from '../../factories'

type fetchListAllTestesProps = {
  page: number
}

type filterListAllTestesProps = {
  page: number
  teste: string
  typeToService: string
}

type resetTestesProps = {
  cdTypeToService: number
  cdTeste: number
}

export const fetchModelTestes = ({
  cdTypeToService,
  cdTeste
}: resetTestesProps) => {
  return new ModelsUseCase(
    `/teste/getTesteText?cdTeste=${cdTeste}&cdTipoAvaliacao=${cdTypeToService}`,
    makeAxiosHttpClient()
  )
}

export const fetchListAllTestes = ({ page = 1 }: fetchListAllTestesProps) => {
  return new ModelsUseCase(`/teste?page=${page}`, makeAxiosHttpClient())
}

export const filterListAllTestes = ({
  page = 1,
  teste,
  typeToService
}: filterListAllTestesProps) => {
  return new ModelsUseCase(
    `/teste/filter?teste=${teste}&tipoAvaliacao=${typeToService}&page=${page}`,
    makeAxiosHttpClient()
  )
}

export const resetTestes = ({ cdTypeToService, cdTeste }: resetTestesProps) => {
  return new ModelsUseCase(
    `/teste/reset?cdTeste=${cdTeste}&cdTipoAvaliacao=${cdTypeToService}`,
    makeAxiosHttpClient()
  )
}

export const saveTesteModel = ({
  cdTeste,
  cdTypeToService
}: resetTestesProps) => {
  return new ModelsUseCase(
    `/teste/save?cdTeste=${cdTeste}&cdTipoAvaliacao=${cdTypeToService}`,
    makeAxiosHttpClient()
  )
}

export const updateTesteModel = () => {
  return new ModelsUseCase(`/teste/update`, makeAxiosHttpClient())
}
